"use client"; // <-- serve per usare usePathname
import { usePathname } from "next/navigation";
import { Footer } from "@components/footer";

export default function FooterManager() {
  const pathname = usePathname();
  const isTarget = pathname.split("/").includes("product");

  return (
    <div className={isTarget ? "hidden md:block" : ""}>
      <Footer />
    </div>
  );
}
